.region {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 60;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
}

.toast {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 280px;
  max-width: 420px;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--c-surface-elevated);
  border: 1px solid var(--c-border-strong);
  box-shadow: var(--shadow-pop);
  font-size: var(--text-caption);
  animation: rise var(--motion-normal) ease-out;
}

@keyframes rise {
  from {
    transform: translateY(8px);
    opacity: 0;
  }
}

.info .icon {
  color: var(--c-brand-muted);
}

.pos .icon {
  color: var(--c-positive);
}

.neg .icon {
  color: var(--c-negative);
}

.close {
  margin-left: auto;
  border: 0;
  background: none;
  color: var(--c-text-tertiary);
  display: flex;
}
